import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import CustomModal from "../../../ui/CustomModal/CustomModal";
import CustomTextInput from "../../../ui/CustomTextInput/CustomTextInput";
import CustomButton from "../../../ui/CustomButton/CustomButton";
import { CallbackUrlValidators } from "../../validations/callbackUrlValidations";

export default function CallbackUrlModal({
  opened,
  onClose,
  control,
  onSubmit,
  isSubmitting,
  isUpdate,
}) {
  return (
    <CustomModal
      opened={opened}
      onClose={onClose}
      title={
        <span className="text-base font-semibold text-gray-900">
          {isUpdate ? "Update Callback URL" : "Add Callback URL"}
        </span>
      }
      centered
      radius="lg"
      overlayProps={{ backgroundOpacity: 0.55, blur: 3 }}
      withCloseButton={!isSubmitting}
      closeOnClickOutside={!isSubmitting}
      closeOnEscape={!isSubmitting}
      styles={{ body: { padding: "0px 24px 24px" } }}
    >
      <Controller
        name="url"
        control={control}
        rules={{
          required: "Callback URL is required",
          maxLength: { value: 100, message: "URL must not exceed 100 characters" },
          validate: CallbackUrlValidators.url,
        }}
        render={({ field, fieldState }) => (
          <CustomTextInput
            {...field}
            label="Callback URL"
            description="Must be an HTTPS endpoint that returns a 2xx response"
            placeholder="https://example.com/webhook"
            radius="md"
            error={fieldState.error?.message}
            maxLength={100}
            disabled={isSubmitting}
          />
        )}
      />
      <div className="mt-4 flex items-center justify-end gap-2">
        <CustomButton
          variant="default"
          color="error"
          onClick={onClose}
          disabled={isSubmitting}
        >
          Cancel
        </CustomButton>
        <CustomButton
          color="dark"
          loading={isSubmitting}
          onClick={onSubmit}
        >
          {isUpdate ? "Update" : "Save"}
        </CustomButton>
      </div>
    </CustomModal>
  );
}

CallbackUrlModal.propTypes = {
  opened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  control: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isUpdate: PropTypes.bool.isRequired,
};
